export default "/static/images/build_roof_13.png?fbe5fd0a0271d773a8b333527627c479";